module.exports = __webpack_public_path__ + "static/media/YF73_03.bad538be.jpg";